<template>
  <div>
    <vs-prompt
      title="Add waste reason"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Add"
      :is-valid="validForm"
      class=""
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Reason</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input v-model="reason" />
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  props: {
    type: {
      type: String,
      // default: false,
    },
  },
  data() {
    return {
      reason: "",
      prompt: false,
    };
  },
  computed: {
    ...mapGetters({}),
    validForm() {
      return this.reason.length > 0;
    },
  },
  methods: {
    show() {
      this.reason = "";
      this.prompt = true;
    },
    async accept() {
      const dto = {
        reason: this.reason,
      };
      this.$store.dispatch(
        `pos/countrySettings/create${this.type}WasteReason`,
        dto
      );
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
